<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="filedType"
        label="筛选项"
        align="center"
        width="240"
      >
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.filedType == 'height'"
            >身高</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.filedType == 'cupSize'"
            >罩杯</el-tag
          >
          <el-tag v-else-if="scope.row.filedType == 'age'">年龄</el-tag>
          <el-tag type="warning" v-else-if="scope.row.filedType == 'feature'"
            >特点</el-tag
          >
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-else-if="scope.row.filedType == 'region'"
            >地区</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="options"
        label="查看配置项"
        align="center"
        min-width="210"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.options && scope.row.options.length"
            size="small"
            @click="viewBtnConfig(scope.row.options)"
            >点击查看</el-button
          >
          <el-button v-else size="small" disabled>点击查看</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          size="small"
          label="筛选项:"
          prop="filedType"
          style="width: 480px"
        >
          <el-select v-model="form.filedType" placeholder="请选择筛选项">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in filedTypes"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="筛选项配置" v-if="form.filedType">
          <el-button type="primary" size="small" @click="openFilterConfig"
            >筛选项配置</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="筛选项配置"
      :visible.sync="filterDialogVisible"
      width="700px"
      @before-close="filterHandleClose"
    >
      <div
        v-for="(item, index) in btns"
        :key="index"
        style="position:relative;display: flex;align-items: center;"
      >
        <template v-if="btns.length !== 0">
          <span style="margin:10px 5px 10px 10px">图标:</span>
          <div @click="uploadImgIndex(index)">
            <el-upload
              style="height: 40px;width: 40px;"
              :headers="header"
              :action="uploadUrl"
              name="upload"
              accept="image/jpeg,image/png,image/jpg, image/gif, image/webp"
              :show-file-list="false"
              :on-success="uploadImg"
              :before-upload="beforeImg"
            >
              <img
                v-if="btns[index].img"
                :src="imgUrl + btns[index].img"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <span style="margin:10px 5px 10px 50px">展示文字:</span>
          <el-input
            type="text"
            size="small"
            v-model="btns[index].text"
            style="width:150px;"
          ></el-input>
          <span style="margin:10px 5px 10px 50px">值:</span>
          <el-input
            type="text"
            size="small"
            v-model="btns[index].value"
            style="width:180px;"
          ></el-input>
          <i
            class="el-icon-circle-plus"
            v-if="index === btns.length - 1"
            style="color:#67c23a;font-size:24px;cursor:pointer;position:absolute;right:20px;top:15px"
            @click="addBtn"
          ></i>
          <i
            class="el-icon-remove"
            v-if="btns.length > 1"
            style="color:#f56c6c;font-size:24px;cursor:pointer;position:absolute;right:-5px;top:15px"
            @click="removeBtn(item)"
          ></i>
        </template>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="filterHandleClose"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="筛选项配置"
      :visible.sync="btnConfigDialog"
      width="700px"
      @before-close="btnConfigHandleClose"
    >
      <div
        v-for="item in viewBtns"
        :key="item.value"
        style="position:relative;display: flex;align-items: center;"
      >
        <template v-if="viewBtns.length !== 0">
          <span style="margin:10px 5px 10px 10px">图标:</span>
          <span style="width: 56px;" v-if="!item.img">暂无图标</span>
          <div
            v-else
            style="width: 56px;"
            @click="handlePictureCardPreview({ url: imgUrl + item.img })"
          >
            <el-image
              style="width: 40px; height: 40px"
              :src="imgUrl + item.img"
              fit="fill"
            ></el-image>
          </div>
          <span style="margin:10px 5px 10px 50px">展示文字:</span>
          <el-input
            type="text"
            size="small"
            v-model="item.text"
            disabled
            style="width:150px;"
          ></el-input>
          <span style="margin:10px 5px 10px 50px">值:</span>
          <el-input
            type="text"
            size="small"
            v-model="item.value"
            disabled
            style="width:180px;"
          ></el-input>
        </template>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import { uniteDate } from "@/utils/validator.js";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      imgUrl: baseConfig.imgUrl,
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      rules: {
        filedType: [
          { required: true, message: "请选择筛选项", trigger: "blur" },
        ],
      },
      filedTypes: [
        {
          label: "身高",
          value: "height",
        },
        {
          label: "罩杯",
          value: "cupSize",
        },
        {
          label: "年龄",
          value: "age",
        },
        {
          label: "特点",
          value: "feature",
        },
        {
          label: "地区",
          value: "region",
        },
      ],
      multiples: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        filedType: undefined, // 属性
        options: undefined,
      },
      filterDialogVisible: false,
      currentIndex: 0, // 当前上传的图片索引
      btns: [
        {
          img: undefined,
          text: undefined,
          value: undefined,
        },
      ],
      viewBtns: [],
      btnConfigDialog: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    uploadImgIndex(index) {
      this.currentIndex = index;
    },
    beforeImg(file) {
      if (!file) return;
      const isLt3M = file.size / 1024 / 1024 < 1.024;
      if (!isLt3M) {
        this.$message.error("封面上传大小不能超过1M");
        return false;
      }
    },
    // 图片上传成功
    uploadImg(res) {
      this.btns[this.currentIndex].img = res.data.coverImg;
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getActressoptList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增
    addAndEdit(param) {
      this.btns = [
        {
          img: undefined,
          text: undefined,
          value: undefined,
        },
      ];
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.filedType = param.filedType;
        if (param.options && param.options.length > 0) {
          this.btns = JSON.parse(JSON.stringify(param.options));
        }
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 增加数量
    addBtn() {
      this.btns.push({
        type: undefined,
        text: undefined,
        value: undefined,
      });
    },
    // 减少数量
    removeBtn(value) {
      this.btns = this.btns.filter((item) => {
        if (item.text !== value.text) {
          return item;
        }
      });
    },
    openFilterConfig() {
      this.filterDialogVisible = true;
    },
    viewBtnConfig(options) {
      this.btnConfigDialog = true;
      this.viewBtns = options;
    },
    // 新增、修改提交
    onSubmit() {
      this.form.options = this.btns.filter((item) => {
        if (item.text && item.value) {
          return item;
        }
      });
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addActressopt(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updateActressopt(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(`确认是否删除此筛选项, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delActressopt(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.filedType = undefined;
      this.form.options = undefined;
      this.dialogVisible = false;
    },
    filterHandleClose() {
      this.filterDialogVisible = false;
    },
    btnConfigHandleClose() {
      this.btnConfigDialog = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.avatar {
  width: 40px;
  height: 40px;
  display: block;
  border-radius: 6px;
  overflow: hidden;
}
</style>
